'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialiseSwiper = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _swiper = require('swiper');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var availableModules = {
  Pagination: _swiper.Pagination,
  Autoplay: _swiper.Autoplay,
  EffectFade: _swiper.EffectFade,
  Navigation: _swiper.Navigation,
  Manipulation: _swiper.Manipulation
};

var initialiseSwiper = exports.initialiseSwiper = function initialiseSwiper(container) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var swiperModules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var modules = swiperModules.map(function (moduleName) {
    return availableModules[moduleName];
  });

  /* eslint-disable no-new */
  return new _swiper.Swiper(container, (0, _assign2.default)({}, config, {
    modules: modules
  }));
};